import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ViewCvComponent} from '../view-cv/view-cv.component';
import { JobsOffersApplicant } from '../../models/jobs-offers-applicant';
import { Constants } from '../constants';
import { InviteService } from '../../services/invite.service';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { ItemInviteUserDetailDialogComponent } from '../item-invite-user-detail-dialog/item-invite-user-detail-dialog.component';
import { CvMapComponent } from '../cv-map/cv-map.component';

@Component({
  selector: 'app-item-candidate-invite',
  templateUrl: './item-candidate-invite.component.html',
  styleUrls: ['./item-candidate-invite.component.css']
})
export class ItemCandidateInviteComponent implements OnInit {
  @Input() user;
  @Input() check_mandatory;
  @Input() job;
  publicating: boolean = false;
  errorMessage: string;

  selectedOption;

  public STATUS = Constants;

  constructor(
    public dialog: MdDialog,
    private inviteService:InviteService) { 
    if (this.check_mandatory!=undefined) {
      this.check_mandatory = true;
    }
  }

  ngOnInit() {
  }

  openCV (userId){
    let dialogRef = this.dialog.open(ViewCvComponent, {
      data: {userId:userId, job: this.job
    }});

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }

  onPostReInvite() {
    if (this.job.status !== -4) {
      let listInvitations = [];
      listInvitations.push({
        email: this.user.email,
        job_id: this.job.id
      });

      this.inviteService.postReInvite(listInvitations, true)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          let txterrors : string = error;
          let jsonErrors : any =  [];          
          jsonErrors =  JSON.parse(txterrors).errors;
          txterrors = '';
          if (jsonErrors.length > 0){
            jsonErrors.forEach(function(element, index) {                                                
                let err: any;
                let txterr: string = "";
                for(err in element.errors){
                  txterr = txterr+" "+element.errors[err][0];
                }
                txterrors = txterrors+"<p class='bg-danger'>"+element.row+" ("+txterr+")</p>";              
                //txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>"; 
            });
          }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>"
          }
          this.publicating = false;
          this.errorMessage = <any>error
          
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txterrors, alert: true, showIcon: true}});
        }
      );
    }
  }

  //noinspection JSMethodCanBeStatic
  percMandatory(user): number {
    if (user.apply != undefined) {
      if(user.apply.mandatoryrequirements > 0) {
        return Math.floor(user.apply.mandatoryrequirementsmet / user.apply.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    } else {
      if(user.mandatoryrequirements > 0) {
        return Math.floor(user.mandatoryrequirementsmet / user.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    }
  }

  //noinspection JSMethodCanBeStatic
  percDesirable(user): number {
    if (user.apply != undefined) {
      if(user.apply.desirablerequirements > 0) {
        return Math.floor(user.apply.desirablerequirementsmet / user.apply.desirablerequirements * 100);
      } else {
        return 0;
      }
    } else {
      if(user.desirablerequirements > 0) {
        return Math.floor(user.desirablerequirementsmet / user.desirablerequirements * 100);
      } else {
        return 0;
      }
    }
  }

  openDetailDialog(user) {
    if (this.job.status !== -4) {
      let dialogRef = this.dialog.open(ItemInviteUserDetailDialogComponent, {
        data: {user: user}
      });
    }
  }

  openCVMap (user) {
    if (this.job.status !== -4) {
      this.dialog.open(CvMapComponent, {
        data: {userId: user.user_id, filters: ''}
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidate-invite/item-candidate-invite.component.ts